<template>
  <WebsiteSelectionGrid
    :items="services"
    title="Leistungen"
    description="Wähle die Leistungen, die für dieses Studio auf der Webseite sichtbar sein sollen."
    icon="mdi-dumbbell"
    fallback-icon="mdi-hammer-wrench"
    empty-title="Keine Leistungen vorhanden"
    empty-text="Aktuell stehen keine Leistungen zur Auswahl."
    @toggle="handleToggle" />
</template>

<script>
import api from "@/api"
import WebsiteSelectionGrid from "./WebsiteSelectionGrid.vue"

export default {
  components: { WebsiteSelectionGrid },
  data() {
    return { services: [] }
  },
  created() {
    this.fetchServices()
  },
  methods: {
    async fetchServices() {
      try {
        this.services = await api.fetchServices()
      } catch (error) {
        this.$toast.error("Fehler beim Laden der Leistungen.")
      }
    },
    handleToggle(item) {
      item.isSelected = !item.isSelected
      this.toggleStudio(item._id, item.isSelected)
    },
    async toggleStudio(id, isSelected) {
      try {
        await api.toggleOfferService(id, isSelected ? "add" : "remove")
      } catch (error) {
        this.$toast.error("Änderung konnte nicht gespeichert werden.")
        const item = this.services.find((entry) => entry._id === id)
        if (item) item.isSelected = !isSelected
      }
    },
  },
}
</script>
